var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"columnBox"},[_c('h1',{staticClass:"study-title"},[_c('img',{attrs:{"src":require("../../../assets/img/learningGuidePage/reporttime.png"),"alt":""}}),_c('span',[_vm._v("学习时长")])]),_c('div',{staticClass:"columnTitle"},[_c('span'),_vm._v("日统计")]),_c('div',{attrs:{"id":"columnchart"}})])
}]

export { render, staticRenderFns }